export const splitFullName = (fullName: string) => {
  if (!fullName || typeof fullName !== 'string' || fullName.trim() === '') {
    return { firstName: '', lastName: '' };
  }
  const nameParts = fullName.trim().split(/\s+/);
  const firstName = nameParts[0] ?? '';
  const lastName = nameParts.slice(1).join(' ') ?? '';
  return { firstName, lastName };
};
